<script setup lang="ts">
  import { UiButton } from '@logistiek-zonder-papier/lzp-library'

  defineProps<{
    title: string
    onClose?: () => void
  }>()

  defineOptions({ inheritAttrs: false })
  const emit = defineEmits(['close'])
</script>

<template>
  <header class="config-header">
    <h3 class="config-title">{{ title }}</h3>
    <UiButton v-if="onClose" @click="emit('close')" icon="cross" size="small" />
  </header>
  <hr />
</template>

<style scoped>
  .config-header {
    gap: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .config-title {
    font-size: 1rem;
    font-weight: 700;
    margin: 0;
  }
</style>
